(()=>{
const $=(s,c=document)=>c.querySelector(s),$$=(s,c=document)=>[...c.querySelectorAll(s)];
const money=c=>{const n=(c/100).toFixed(2);return '£'+(n.endsWith('.00')?n.slice(0,-3):n)};
const openD=d=>{if(d&&!d.open)d.showModal()};
const closeD=d=>{if(d&&d.open)d.close()};
const hdr=$('[data-hdr]');
if(hdr){const s=document.createElement('div');s.style.cssText=`position:absolute;left:0;width:1px;height:1px;pointer-events:none;top:${hdr.parentElement.offsetTop+1}px`;document.body.append(s);new IntersectionObserver(([e])=>hdr.classList.toggle('is-stuck',!e.isIntersecting)).observe(s)}
const aos=new IntersectionObserver(es=>es.forEach(e=>{if(e.isIntersecting){e.target.classList.add('in');aos.unobserve(e.target)}}),{rootMargin:'0px 0px -6% 0px'});
$$('[data-aos]').forEach(el=>aos.observe(el));
const ann=$('[data-ann]');
try{if(ann&&sessionStorage.getItem('ann')==='0')ann.hidden=true}catch(e){}
const swapCart=html=>{
const doc=new DOMParser().parseFromString(html,'text/html'),next=$('[data-cart-root]',doc),cur=$('[data-cart-root]');
if(!next||!cur)return;
const top=$('.cd__body',cur)?.scrollTop||0;
cur.replaceWith(next);
const b=$('.cd__body',next);if(b)b.scrollTop=top;
const n=+next.dataset.count;
$$('[data-cart-count]').forEach(c=>{c.textContent=n;c.hidden=n===0});
};
const onCartPage=()=>!!$('[data-cart-page]');
const cartError=m=>{const e=$('[data-cart-error]');if(e){e.textContent=m;e.hidden=false}};
const post=async(url,body)=>{
const r=await fetch(url,{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify(body)});
const j=await r.json();
if(!r.ok)throw new Error(j.description||j.message||'Sorry, that did not work.');
return j};
const change=async(line,quantity)=>{
try{const j=await post('/cart/change.js',{line:+line,quantity:+quantity,sections:['cart-drawer']});
if(onCartPage())return location.reload();
swapCart(j.sections['cart-drawer'])}catch(e){cartError(e.message)}};
const add=async form=>{
const btn=$('button[type=submit]',form),err=$('[data-form-error]',form),data=new FormData(form),items={id:+data.get('id'),quantity:+(data.get('quantity')||1)};
const props={};for(const[k,v]of data)if(k.startsWith('properties['))props[k.slice(11,-1)]=v;
if(Object.keys(props).length)items.properties=props;
if(btn)btn.disabled=true;if(err)err.hidden=true;
try{const j=await post('/cart/add.js',{items:[items],sections:['cart-drawer']});
if(onCartPage())return location.reload();
swapCart(j.sections['cart-drawer']);openD($('#cart'))}
catch(e){if(err){err.textContent=e.message;err.hidden=false}else{cartError(e.message);openD($('#cart'))}}
if(btn)btn.disabled=false};
document.addEventListener('submit',e=>{
const f=e.target;
if(f.matches('form[action*="/cart/add"]')&&!e.submitter?.classList.contains('shopify-payment-button__button')){e.preventDefault();add(f)}});
document.addEventListener('click',e=>{
const t=e.target.closest('[data-open],[data-close],[data-line],[data-ann-close],[data-video],[data-zoom],[data-thumb],[data-step],[data-satc-add],[data-tab]');
if(e.target.matches('dialog'))return e.target.close();
if(!t)return;
if(t.dataset.open){e.preventDefault();closeD($('#menu'));openD($('#'+t.dataset.open))}
else if('close'in t.dataset)closeD(t.closest('dialog'));
else if(t.dataset.line){t.disabled=true;change(t.dataset.line,t.dataset.q)}
else if('annClose'in t.dataset){ann.hidden=true;try{sessionStorage.setItem('ann','0')}catch(e){}}
else if(t.dataset.video){const f=document.createElement('iframe');f.src=t.dataset.video;f.allow='autoplay; fullscreen';f.title='Video';const v=t.closest('.vid');v.replaceChildren(f);v.style.setProperty('--o',0)}
else if(t.dataset.zoom){const l=$('#lightbox'),i=$('img',l);i.src=t.dataset.zoom;i.hidden=false;openD(l)}
else if(t.dataset.thumb){const m=$('.gallery__main',t.closest('[data-gallery]'));m.scrollTo({left:m.clientWidth*+t.dataset.thumb})}
else if(t.dataset.step){const i=$('input',t.parentNode);i.value=Math.max(1,+i.value+ +t.dataset.step)}
else if('satcAdd'in t.dataset)$('[data-pform]').requestSubmit();
else if(t.dataset.tab){const w=t.closest('[data-tabs]');$$('[data-tab]',w).forEach(b=>b.setAttribute('aria-selected',b===t));$$('[role=tabpanel]',w).forEach(p=>p.hidden=p.id!=='panel-'+t.dataset.tab)}
});
$$('.gallery__main').forEach(m=>{const th=$$('[data-thumb]',m.parentNode);let f;
m.addEventListener('scroll',()=>{cancelAnimationFrame(f);f=requestAnimationFrame(()=>{const i=Math.round(m.scrollLeft/m.clientWidth);th.forEach((b,n)=>n===i?b.setAttribute('aria-current','true'):b.removeAttribute('aria-current'))})},{passive:true})});
const root=$('[data-product]');
if(root){
const variants=JSON.parse($('[data-variants]',root).textContent),form=$('[data-pform]',root),radios=$$('[data-o]',root),add=$('[data-add]',root),sAdd=$('[data-satc-add]',root),stock=$('[data-stock]',root),sticky=$('[data-satc]',root);
const update=()=>{
const sel=[...new Set(radios.map(r=>r.dataset.o))].map(o=>$(`[data-o="${o}"]:checked`,root)?.value);
const v=variants.find(x=>sel.every((s,i)=>x.options[i]===s));
const txt=!v?'Unavailable':v.available?'Add to basket':'Sold out';
[add,sAdd].forEach(b=>{b.textContent=txt;b.disabled=!v?.available});
if(!v)return;
$('[data-vid]',root).value=v.id;
const sk=$('[data-sku]',root);if(sk)sk.textContent=v.sku||'';
$$('[data-price]',root).forEach(p=>p.textContent=money(v.price));
const c=$('[data-compare]',root);c.hidden=!(v.compare_at_price>v.price);if(!c.hidden)c.textContent=money(v.compare_at_price);
stock.textContent=v.available&&v.inventory_management==='shopify'&&v.inventory_policy==='deny'&&v.inventory_quantity>0&&v.inventory_quantity<=5?`Only ${v.inventory_quantity} left`:'';
const u=new URL(location);u.searchParams.set('variant',v.id);history.replaceState(null,'',u);
const m=v.featured_media&&$(`[data-media="${v.featured_media.id}"]`,root);
if(m){const g=$('.gallery__main',root);g.scrollTo({left:m.offsetLeft-g.offsetLeft})}};
radios.forEach(r=>r.addEventListener('change',update));
if(sticky&&innerWidth<992)new IntersectionObserver(([e])=>{sticky.hidden=e.isIntersecting||e.boundingClientRect.top>0}).observe(form);
}
const recs=$('[data-recs]');
if(recs)fetch(recs.dataset.recs).then(r=>r.text()).then(h=>{const n=$('[data-recs]',new DOMParser().parseFromString(h,'text/html'));if(n)recs.innerHTML=n.innerHTML}).catch(()=>{});
const filters=$('[data-filters]');
if(filters){filters.addEventListener('change',()=>{
const p=new URLSearchParams(new FormData(filters));for(const[k,v]of[...p])if(!v)p.delete(k);
location.search=p.toString()});
document.addEventListener('click',e=>{$$('.flt[open]').forEach(d=>{if(!d.contains(e.target))d.open=false})})}
})();
